module.exports = __webpack_public_path__ + "img/AT0000002625794.a6731837.png";